import { render, staticRenderFns } from "./VotingGaugeByNpModal.vue?vue&type=template&id=0a45c6cf&scoped=true&"
import script from "./VotingGaugeByNpModal.vue?vue&type=script&lang=js&"
export * from "./VotingGaugeByNpModal.vue?vue&type=script&lang=js&"
import style0 from "./VotingGaugeByNpModal.vue?vue&type=style&index=0&id=0a45c6cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a45c6cf",
  null
  
)

export default component.exports